import { useLogout } from '@/features/auth/use-logout';
import { Button } from '@/shared/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';
import { useSubscriptionStore } from './useSubscriptionStore';

export function SubscriptionBlockedModal() {
  const blocked = useSubscriptionStore((s) => s.blocked);
  const logout = useLogout();

  return (
    <Dialog open={blocked} onOpenChange={() => {}}>
      <DialogContent className="max-w-md" hideClose>
        <DialogHeader>
          <DialogTitle>Доступ временно ограничен</DialogTitle>
          <DialogDescription>
            Подписка вашей организации завершилась или приостановлена.
            Для возобновления доступа обратитесь к администратору платформы.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Все данные сохранены. Вы получите доступ сразу после активации подписки.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => { void logout(); }}>
            Выйти
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
